// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3epQD","alertIcon":"ConfirmModal_alertIcon__XwP6M"};